<template>
  <div class="form-group">
    <label v-if="labelText"
           for="file_input"
           :class="labelClass">{{ labelText }}
      <abbr v-if="required"
            style="text-decoration: none;"
            title="Campo obligatorio">*</abbr>
    </label>
    <div :class="( isCustomFile ? 'custom-file' : '')">
      <input :id="inputId"
             :name="inputName"
             :class="inputClass"
             :data-id="inputId"
             :data-update-file="dataUpdateFile"
             @change="fileUpdated()"
             ref="file"
             accept="application/pdf"
             type="file">
      <label :for="inputId"
             class="custom-file-label"
             v-if="isCustomFile"
             data-browse="Buscar">{{ inputPlaceHolder }}</label>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'FileInput',
    props: {
      inputId: {
        type: String,
        default: 'custom-file-input',
      },
      inputName: {
        type: String,
        default: 'custom-file-input',
      },
      inputClass: {
        type: String,
        default: 'custom-file-input',
      },
      inputPlaceHolder: {
        type: String,
        default: 'Seleccione un archivo',
      },
      labelText: {
        type: String,
        default: null,
      },
      labelClass: {
        type: String,
        default: 'd-block font-weight-normal',
      },
      required: {
        type: Boolean,
        default: false,
      },
      isCustomFile: {
        type: Boolean,
        default: true,
      },
      dataUpdateFile: {
        type: Number,
        default: null,
      },
    },
    data: () => ({}),
    methods: {
      fileUpdated () {
          $(`#${ this.inputId }`).rules('add', {
          extension: 'pdf',
          maxsize: (this.isAdmin() ? 5 : 2) * 1024 * 1024,
          messages: {
            extension: 'El formato del archivo debe ser PDF.',
            maxsize: `El tamaño del archivo no debe superar los ${ this.isAdmin() ? 5 : 2 } MB.`,
          },
        })
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      },
    },
    computed: {
      ...mapGetters(['user']),
    },
    mounted () {
      /**
       * Fix file name change on validating inputs
       */
      $(`#${ this.inputId }`).on('change', function () {
        var fileName = $(this).val().split('\\').pop()
        $(this).nextAll('.custom-file-label').html(fileName)
      })
    },
  }
</script>
